import { render, staticRenderFns } from "./InputAssessment.vue?vue&type=template&id=0df1f4da&scoped=true"
import script from "./InputAssessment.vue?vue&type=script&lang=js"
export * from "./InputAssessment.vue?vue&type=script&lang=js"
import style0 from "./InputAssessment.vue?vue&type=style&index=0&id=0df1f4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1f4da",
  null
  
)

export default component.exports